export default "__VITE_ASSET__DmFyyM5f__"